(function () {

  function initZtVariantCards() {

    const groups = document.querySelectorAll(
      '[data-zt-variant-cards]'
    );


    groups.forEach(function (group) {

      if (group.dataset.initialized === 'true') {
        return;
      }

      group.dataset.initialized = 'true';


      const cards = Array.from(
        group.querySelectorAll('.zt-variant-card')
      );


      const productInfo =
        group.closest('product-info') ||
        document;


      /* ==================================================
         EIGENEN PREISBLOCK FINDEN
         ================================================== */

      function getCustomPriceBox() {

        return (
          productInfo.querySelector(
            '[data-zt-product-price]'
          ) ||
          document.querySelector(
            '[data-zt-product-price]'
          )
        );

      }


      /* ==================================================
         EIGENEN PREIS AKTUALISIEREN
         ================================================== */

      function updateCustomPrice(card) {

        const priceBox =
          getCustomPriceBox();


        if (!priceBox) {

          console.warn(
            'ZuhauseTEST: eigener Preisblock wurde nicht gefunden.'
          );

          return;

        }


        const price =
          card.dataset.price || '';


        const comparePrice =
          card.dataset.comparePrice || '';


        const savingPercent =
          parseInt(
            card.dataset.savingPercent || '0',
            10
          );


        const testCount =
          parseInt(
            card.dataset.testCount || '1',
            10
          );


        const unitPrice =
          card.dataset.unitPrice || '';


        const current =
          priceBox.querySelector(
            '[data-zt-price-current]'
          );


        const compare =
          priceBox.querySelector(
            '[data-zt-price-compare]'
          );


        const badge =
          priceBox.querySelector(
            '[data-zt-price-badge]'
          );


        const unit =
          priceBox.querySelector(
            '[data-zt-unit-price]'
          );


        /* Aktueller Preis */

        if (current) {

          current.textContent =
            price;

        }


        /* Preis pro Test */

        if (unit) {

          if (
            testCount > 1 &&
            unitPrice
          ) {

            unit.textContent =
              'nur ' + unitPrice + '/Test';

            unit.hidden =
              false;

          } else {

            unit.textContent =
              '';

            unit.hidden =
              true;

          }

        }


        /* Rabatt vorhanden */

        if (
          comparePrice &&
          savingPercent > 0
        ) {

          priceBox.classList.add(
            'is-sale'
          );


          if (compare) {

            compare.textContent =
              comparePrice;

            compare.hidden =
              false;

          }


          if (badge) {

            badge.textContent =
              'Spare ' +
              savingPercent +
              ' %';

            badge.hidden =
              false;

          }

        }


        /* Kein Rabatt */

        else {

          priceBox.classList.remove(
            'is-sale'
          );


          if (compare) {

            compare.textContent =
              '';

            compare.hidden =
              true;

          }


          if (badge) {

            badge.textContent =
              '';

            badge.hidden =
              true;

          }

        }


        priceBox.dataset.variantId =
          card.dataset.variantId || '';

      }


      /* ==================================================
         AKTIVE KARTE
         ================================================== */

      function setActiveCard(variantId) {

        cards.forEach(function (card) {

          card.classList.toggle(
            'is-active',
            String(card.dataset.variantId) ===
            String(variantId)
          );

        });

      }


      /* ==================================================
         PRODUKTFORMULAR AKTUALISIEREN
         ================================================== */

      function updateVariantInputs(variantId) {

        const forms =
          productInfo.querySelectorAll(
            'form[action*="/cart/add"]'
          );


        forms.forEach(function (form) {

          const input =
            form.querySelector(
              'input[name="id"]'
            );


          if (!input) {
            return;
          }


          input.value =
            variantId;


          input.dispatchEvent(
            new Event(
              'change',
              {
                bubbles: true
              }
            )
          );

        });

      }


      /* ==================================================
         NATIVEN SHOPIFY VARIANTENPICKER SYNCHRONISIEREN
         ================================================== */

      function syncNativePicker(card) {

        const picker =
          productInfo.querySelector(
            'variant-selects, variant-radios'
          );


        if (!picker) {
          return;
        }


        const values = [
          card.dataset.option1,
          card.dataset.option2,
          card.dataset.option3
        ];


        /* SELECTS */

        const selects =
          Array.from(
            picker.querySelectorAll('select')
          );


        selects.forEach(function (select, index) {

          const value =
            values[index];


          if (!value) {
            return;
          }


          if (select.value !== value) {

            select.value =
              value;


            select.dispatchEvent(
              new Event(
                'change',
                {
                  bubbles: true
                }
              )
            );

          }

        });


        /* RADIOS */

        const fieldsets =
          Array.from(
            picker.querySelectorAll('fieldset')
          );


        fieldsets.forEach(function (fieldset, index) {

          const value =
            values[index];


          if (!value) {
            return;
          }


          const radio =
            Array.from(
              fieldset.querySelectorAll(
                'input[type="radio"]'
              )
            ).find(function (input) {

              return input.value === value;

            });


          if (
            radio &&
            !radio.checked
          ) {

            radio.checked =
              true;


            radio.dispatchEvent(
              new Event(
                'change',
                {
                  bubbles: true
                }
              )
            );

          }

        });

      }


      /* ==================================================
         URL AKTUALISIEREN
         ================================================== */

      function updateUrl(variantId) {

        const url =
          new URL(
            window.location.href
          );


        url.searchParams.set(
          'variant',
          variantId
        );


        window.history.replaceState(
          {},
          '',
          url.toString()
        );

      }


      /* ==================================================
         KLICK
         ================================================== */

      cards.forEach(function (card) {

        card.addEventListener(
          'click',
          function () {

            if (card.disabled) {
              return;
            }


            const variantId =
              card.dataset.variantId;


            if (!variantId) {
              return;
            }


            setActiveCard(
              variantId
            );


            /*
             * Unser Preis wird bewusst direkt aktualisiert.
             */

            updateCustomPrice(
              card
            );


            /*
             * Shopify synchronisieren.
             */

            syncNativePicker(
              card
            );


            updateVariantInputs(
              variantId
            );


            /*
             * URL
             */

            updateUrl(
              variantId
            );

          }
        );

      });


      /* ==================================================
         INITIALER PREIS
         ================================================== */

      const activeCard =
        group.querySelector(
          '.zt-variant-card.is-active'
        );


      if (activeCard) {

        updateCustomPrice(
          activeCard
        );

      }

    });

  }


  document.addEventListener(
    'DOMContentLoaded',
    initZtVariantCards
  );


  document.addEventListener(
    'shopify:section:load',
    initZtVariantCards
  );

})();
